import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import LocaleStrings from "Languages";
import { fetchadvertisementclickanalytics } from "AdvertisementinsightActions";
import AdsclicklistItem from "./adclick-list";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class Addclickbox extends Component {
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props) {
    super(props);
    //this.state            = this.getInitialState();
    this.state = {
      from: moment().subtract(30, "day").endOf("day").toDate(),
      to: moment().toDate(),
      loading: true,
      desc: LocaleStrings.analytics_adclick_preparing,
      loader: false,
      pageNumber: 1,
      activeLoader: false,
      showPicker: false,
    };
  }

  componentDidMount() {
    this.props.fetchadvertisementclickanalytics(
      this.props.session,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  renderaddclickList() {
    return _.map(
      this.props.advertisementclickAnalyticsdatalist.data,
      (values, index) => {
        return <AdsclicklistItem key={index} values={values} />;
      }
    );
  }

  render() {
    var { advertisementclickAnalyticsdatalist } = this.props;
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    // console.log('advertisementclickAnalyticsdatalist', advertisementclickAnalyticsdatalist)
    return (
      <div className="panel noborder-panel">
        <div className="clearfix" />
        {/* Header */}
        <div className="panel-body scrollable-content">
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {advertisementclickAnalyticsdatalist &&
              advertisementclickAnalyticsdatalist.data.length > 0 ? (
                <div
                  className="panel-body scrollable-content"
                  // style={{ height: deviceSize.height - 175 }}
                >
                  <div className="">
                    <table className="table">
                      <thead>
                        <tr>
                          <th align="center">
                            {LocaleStrings.analytics_ad_th1}
                          </th>
                          <th align="center">
                            {LocaleStrings.analytics_ad_th2}
                          </th>
                          <th align="center">
                            {LocaleStrings.analytics_ad_th3}
                          </th>
                          <th align="center">
                            {LocaleStrings.analytics_ad_th4}
                          </th>
                          <th align="center">
                            {LocaleStrings.analytics_ad_th5}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="tbody-background">
                        {this.renderaddclickList()}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="loader-container mt-60">
                  {LocaleStrings.analytic_no_advertisement_clicked}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    client_historydata: state.client_historydata,
    clientdataforbilling: state.clientdataforbilling,
    advertisementclickAnalyticsdatalist:
      state.advertisementclickAnalyticsdatalist,
  };
}

export default connect(mapStateToProps, {
  fetchadvertisementclickanalytics,
})(Addclickbox);
